"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var checkmarkSvg = function checkmarkSvg(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _constants.colors.mediumGreenhouseGreen : _ref$color,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M4.732 9.435c-.377-.404-1.01-.427-1.414-.05-.404.376-.426 1.01-.05 1.413L7.22 15.04c.376.404 1.006.428 1.41.054l9.05-8.36c.404-.374.43-1.007.054-1.413-.374-.404-1.007-.43-1.413-.054L8.006 12.95 4.732 9.434z"
  }));
};
var Checkmark = (0, _styledComponents["default"])(checkmarkSvg).attrs(function (_ref2) {
  var verticalAlign = _ref2.verticalAlign;
  return {
    verticalAlign: verticalAlign || 'baseline'
  };
}).withConfig({
  displayName: "checkmark__Checkmark"
})(["vertical-align:", ";"], function (props) {
  return props.verticalAlign;
});
Checkmark.displayName = 'Checkmark';
var _default = exports["default"] = Checkmark;